import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/api";

const LOGO_URL = "/wre-logo.jpg";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink-600 bg-ink-800 mt-32">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 border-b border-ink-600">
        <div className="md:col-span-4 p-8 border-r border-ink-600">
          <div className="flex items-center gap-3 mb-5">
            <span className="grid place-items-center h-14 w-20 bg-ink-900 border border-ink-600 overflow-hidden shrink-0">
              <img src={LOGO_URL} alt="Washington Rotating Electrics" className="max-w-full max-h-full object-contain" />
            </span>
            <div className="font-display text-xl chrome-text">{COMPANY.short}</div>
          </div>
          <p className="text-steel-400 text-sm leading-relaxed max-w-sm">
            Specialist supplier of starter motors and alternators for HGV, PSV,
            industrial and marine applications across the UK.
            Tested. Guaranteed. Shipped.
          </p>
          <div className="mt-6 font-mono-tech text-[10px] text-steel-500">
            WRE · WASHINGTON · NORTH EAST ENGLAND
          </div>
        </div>

        <div className="md:col-span-3 p-8 border-r border-ink-600">
          <div className="font-mono-tech text-[10px] text-copper mb-4">NAVIGATE</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-copper">Home</Link></li>
            <li><Link to="/about" className="hover:text-copper">About Us</Link></li>
            <li><Link to="/catalog" className="hover:text-copper">Product Catalog</Link></li>
            <li><Link to="/quote" className="hover:text-copper">Request a Quote</Link></li>
            <li><Link to="/contact" className="hover:text-copper">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2 p-8 border-r border-ink-600">
          <div className="font-mono-tech text-[10px] text-copper mb-4">STARTER MOTORS</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/catalog?type=starter-motor&segment=hgv" className="hover:text-copper">HGV</Link></li>
            <li><Link to="/catalog?type=starter-motor&segment=bus" className="hover:text-copper">Bus / PSV</Link></li>
            <li><Link to="/catalog?type=starter-motor&segment=industrial" className="hover:text-copper">Industrial</Link></li>
            <li><Link to="/catalog?type=starter-motor&segment=marine" className="hover:text-copper">Marine</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3 p-8">
          <div className="font-mono-tech text-[10px] text-copper mb-4">CONTACT</div>
          <ul className="space-y-3 text-sm text-steel-200">
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 text-copper shrink-0" />{COMPANY.address}</li>
            <li>
              <a
                href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`}
                data-testid="footer-phone-link"
                className="flex items-center gap-2 hover:text-copper transition-colors"
              >
                <Phone size={14} className="text-copper shrink-0" />{COMPANY.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-2 hover:text-copper transition-colors break-all"
              >
                <Mail size={14} className="text-copper shrink-0" />{COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-center px-5 py-4 font-mono-tech text-[10px] text-steel-500 gap-2">
        <div>© {new Date().getFullYear()} {COMPANY.name}. ALL RIGHTS RESERVED.</div>
        <div>UK-WIDE NEXT-DAY DELIVERY</div>
      </div>
    </footer>
  );
}
